// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"YK-z","carouselContainer":"ZK-z"};